<template>
  <div v-if="result.items?.length" class="instagram-looks">
    <div class="instagram-looks-grid">
      <div class="instagram-looks-header">
        <h2 class="instagram-looks-header__title">
          {{ messages.blockTitle }}
        </h2>
        <p class="instagram-looks-header__text">{{ messages?.findTheLooks }}</p>
        <!--      <a-->
        <!--        v-if="messages && messages.blockHashTag"-->
        <!--        :href="messages.blockHashTag.href"-->
        <!--        class="instagram-looks__hash"-->
        <!--      >-->
        <!--        {{ messages.blockHashTag.name }}-->
        <!--      </a>-->
      </div>
      <!-- I can't move to wrapper v-if directive! I've used css grid here-->
      <InstagramCard
        v-for="item in getItems"
        v-if="screenWidth >= 762"
        :key="item.id"
        :result="item"
        :messages="messages"
      />
    </div>

    <DefSlider
      v-if="screenWidth < 762"
      ref="slider"
      :nav="false"
      :pagination="true"
      :settings="settings"
    >
      <div v-for="item in getItems" :key="item.id" class="swiper-slide">
        <InstagramCard :result="item" :messages="messages" />
      </div>
    </DefSlider>

    <div class="instagram-looks__look">
      <DefButtonSecondary
        v-if="messages && messages.blockHashTag"
        :href="messages.blockHashTag.href"
      >
        <svg class="instagram-icon" width="21" height="20" viewBox="0 0 21 20">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.76632 6.28137C3.76632 4.6162 5.1162 3.26632 6.78137 3.26632H14.319C15.9842 3.26632 17.3341 4.6162 17.3341 6.28137V13.819C17.3341 15.4842 15.9842 16.8341 14.319 16.8341H6.78137C5.1162 16.8341 3.76632 15.4842 3.76632 13.819V6.28137ZM6.78137 1.75879C4.28362 1.75879 2.25879 3.78362 2.25879 6.28137V13.819C2.25879 16.3168 4.28362 18.3416 6.78137 18.3416H14.319C16.8168 18.3416 18.8416 16.3168 18.8416 13.819V6.28137C18.8416 3.78362 16.8168 1.75879 14.319 1.75879H6.78137ZM14.696 5.15075C14.2797 5.15075 13.9422 5.48822 13.9422 5.90451C13.9422 6.3208 14.2797 6.65828 14.696 6.65828H14.7035C15.1198 6.65828 15.4573 6.3208 15.4573 5.90451C15.4573 5.48822 15.1198 5.15075 14.7035 5.15075H14.696ZM9.54141 8.01043C9.96359 7.79136 10.4441 7.711 10.9146 7.78077C11.3945 7.85193 11.8388 8.07556 12.1819 8.41863C12.5249 8.76169 12.7486 9.20599 12.8197 9.68591C12.8895 10.1564 12.8091 10.6369 12.5901 11.0591C12.371 11.4813 12.0244 11.8236 11.5996 12.0375C11.1747 12.2513 10.6932 12.3257 10.2236 12.2502C9.75405 12.1746 9.32024 11.9529 8.98392 11.6166C8.6476 11.2803 8.42589 10.8464 8.35032 10.3769C8.27476 9.90726 8.34919 9.4258 8.56303 9.00095C8.77687 8.5761 9.11923 8.22949 9.54141 8.01043ZM11.1357 6.28955C10.3516 6.17327 9.55073 6.30721 8.84709 6.67231C8.14345 7.03741 7.57285 7.61509 7.21645 8.32318C6.86005 9.03126 6.736 9.8337 6.86194 10.6164C6.98788 11.399 7.3574 12.122 7.91794 12.6826C8.47848 13.2431 9.20149 13.6126 9.98414 13.7386C10.7668 13.8645 11.5692 13.7404 12.2773 13.384C12.9854 13.0276 13.5631 12.457 13.9282 11.7534C14.2933 11.0498 14.4272 10.2489 14.311 9.46478C14.1923 8.66492 13.8196 7.92441 13.2479 7.35264C12.6761 6.78087 11.9356 6.40816 11.1357 6.28955Z"
            fill="#030304"
          />
        </svg>

        {{ messages.blockHashTag.name }}
      </DefButtonSecondary>
    </div>
  </div>
</template>

<script>
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import useModal from '@use/useModal/useModal';
import useScreenWidth from '@use/useScreenWidth';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import InstagramCard from '@components/sliders/InstagramLooks/InstagramCard.vue';

export default {
  name: 'InstagramLooks',
  components: { InstagramCard, DefButtonSecondary, DefSlider },
  props: ['result'],
  data() {
    return {
      screenWidth: useScreenWidth(),
      settings: {
        slidesPerView: 1.3,
      },
      modal: useModal(),
    };
  },
  computed: {
    messages() {
      return this.result?.messages;
    },
    getItems() {
      if (this.screenWidth >= 992) {
        return this.result.items?.slice(0, 4);
      }
      if (this.screenWidth >= 768) {
        return this.result.items?.slice(0, 3);
      }
      return this.result.items;
    },
  },
};
</script>

<style lang="scss" scoped>
.instagram-looks {
  margin-bottom: 60px;
  @include point-lg {
    margin-bottom: 80px;
  }
  &__look {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    padding: 0 16px;
  }
}
.instagram-looks-header {
  background-color: #f0e9e0;
  padding: 32px;
  grid-column: 1 / 3;
  &__title {
    font-family: 'PT Serif';
    font-size: 24px;
    font-style: italic;
    font-weight: 400;
    line-height: 135%;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 16px;
  }
  &__text {
    font-size: 16px;
    font-weight: 500;
    line-height: 125%;
    margin-bottom: 0;
    text-align: center;
    @include point-lg {
      font-size: 18px;
    }
  }
}
.instagram-looks-cards {
}
.instagram-looks-grid {
  @include point-md {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-auto-rows: 1fr;
    :deep(.instagram-card) {
      grid-column: span 2;
      grid-row: span 2;
      &:nth-child(2) ~ * {
        grid-column: span 1;
        grid-row: span 1;
      }
    }
  }
  @include point-lg {
    grid-template-columns: repeat(6, minmax(0, 1fr));
    :deep(.instagram-card) {
      grid-column: span 2;
      grid-row: span 2;
      &:nth-child(3) {
        grid-column: span 2;
        grid-row: span 2;
      }
      &:nth-child(3) ~ * {
        grid-column: span 1;
        grid-row: span 1;
      }
    }
  }
}
.instagram-icon {
  margin-right: 4px;
}
</style>
